import { render, staticRenderFns } from "./TermsPrivacy.vue?vue&type=template&id=a3035eac&scoped=true&"
import script from "./TermsPrivacy.vue?vue&type=script&lang=js&"
export * from "./TermsPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./TermsPrivacy.vue?vue&type=style&index=0&id=a3035eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3035eac",
  null
  
)

export default component.exports